import CloseIcon from '@/assets/icons/close-icon.svg';
import { Palette } from '@/themes/themeOverrides/Palette';

export const MuiChipStyles = {
    styleOverrides: {
        root: {
            '& .MuiChip-label': {
                fontSize: '11px',
            },
            '&.pos-field-name-chip': {
                backgroundColor: Palette.violet.violet700,
                color: Palette.white,
                borderRadius: '4px',
                height: '16px',
                '& .MuiChip-label': {
                    padding: '0 6px',
                },
            },
        },
        deleteIcon: {
            '&.MuiChip-deleteIcon': {
                backgroundImage: `url("${CloseIcon}")`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                transform: 'rotate(0deg)',
                transition: '0.3s ease',
                '&:hover': {
                    transform: 'rotate(180deg)',
                },
                '& path': {
                    visibility: 'hidden',
                },
            },
        },
    },
};
